export enum ECheckResultForRemovedPunchData {
    Valid,
    HierarchyRemoved,
    PositionRemoved
}